import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import request from "../util/request";
import {
    validate_real_time_request_params_success,
    validate_real_time_request_params_failed,

    get_real_time_data_success,
    get_real_time_data_failed,
} from "actions/realtime";

import {
    VALIDATE_REAL_TIME_REQUEST_PARAMS,
    GET_REAL_TIME_DATA,
} from "constants/ActionTypes";

function* validate_real_time_request_params_saga({ payload }) {
    try {
        const { id, did, start_time, end_time, user_ids } = payload;
        const requiredParam = [];

        let didParam = 'did=';
        if (did) {
            didParam += did;
        } else {
            didParam += '0';
        }

        if(user_ids){
             requiredParam.push('user_ids='+user_ids.map(u => u.user_id).join(','))
        }

        if (id) {
            requiredParam.push('pid=' + id);
        }

        if (start_time) {
            requiredParam.push('start_time=' + start_time);
        }

        if (end_time) {
            requiredParam.push('end_time=' + end_time);
        }

        let params = '';
        if (requiredParam.length > 0) {
            params = '?';
        }
        params += requiredParam.map(p => p).join('&');

        const response = yield call(request, {
            path: `/device/real-time-validation/${didParam}${params}`,
            method: "GET"
        })

        if (response.status === 200) {
            yield put(validate_real_time_request_params_success(response))
        } else {
            yield put(validate_real_time_request_params_failed(response))
        }
    } catch (error) {
        console.error(error)
    }
}

function* get_real_time_data_saga({ payload }) {
    try {
        const { id, did, start_time, end_time } = payload;
        const requiredParam = [];

        let didParam = 'did=';
        if (did) {
            didParam += did;
        } else {
            didParam += '0';
        }

        if (id) {
            requiredParam.push('pid=' + id);
        }

        if (start_time) {
            requiredParam.push('start_time=' + start_time);
        }

        if (end_time) {
            requiredParam.push('end_time=' + end_time);
        }

        let params = '';
        if (requiredParam.length > 0) {
            params = '?';
        }
        params += requiredParam.map(p => p).join('&');
        // console.log(params);

        const response = yield call(request, {
            path: `/device/real-time/${didParam}${params}`,
            method: "GET"
        })

        if (response.status === 200) {
            yield put(get_real_time_data_success(response))
        } else {
            yield put(get_real_time_data_failed(response))
        }
    } catch (error) {
        console.error(error)
    }
}

export function* validate_real_time_request_params() {
    yield takeEvery(VALIDATE_REAL_TIME_REQUEST_PARAMS, validate_real_time_request_params_saga);
}

export function* get_real_time_data() {
    yield takeEvery(GET_REAL_TIME_DATA, get_real_time_data_saga);
}

export default function* rootSaga() {
    yield all([
        fork(validate_real_time_request_params),
        fork(get_real_time_data)
    ]);
}